module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/.pnpm/babel-loader@9.2.1_@babel+core@7.29.7_supports-color@8.1.1__webpack@5.112.0/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[1].use[0]!./index.js"));
	});
}